<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <h4 class="mb-2.5">
                    本次投資金額
                </h4>
                <div class="border-green-gray py-2 px-2.5 md:py-3.5 md:px-5 mb-3.5">
                    <div class="text-gray-900 text-base xs:text-lg">
                        {{ addComma(after.amount) }}元
                    </div>
                </div>
                <h4 class="mb-2.5">
                    配置比例
                </h4>
                <div class="border-green-gray py-2 px-2.5 md:py-3.5 md:px-5 mb-3.5 md:mb-5">
                    <ul class="divide-dashed divide-y -mr-2.5 md:-mr-4">
                        <li
                            v-for="(item, index) in after.singlePremResultDataList"
                            :key="index"
                            class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0 text-gray-900"
                        >
                            <div class="md:mr-4 w-4/5 md:flex-shrink-0">
                                <span>
                                    {{ `${item.fundCode} ${item.fundName}` }}
                                </span>
                            </div>
                            <div class="px-3 text-right w-16">
                                <span>
                                    {{ `${item.percent}%` }}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <h4 class="mb-2.5">
                    資金來源及財務狀況
                </h4>
                <h5 class="mb-1.5">
                    資金來源
                </h5>
                <div class="text-gray-700 text-base xs:text-lg mb-2.5">
                    {{ sourseDisplay }}
                </div>
                <h5 class="mb-1.5">
                    財務狀況
                </h5>
                <div
                    v-for="item in financialConditionDisplay"
                    :key="item.id"
                    class="text-gray-700 text-base xs:text-lg"
                >
                    {{ item.name }}：{{ item.amount }} 萬元
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import { addComma } from '@/utils/number/addComma';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';

export default {
    name: 'A5Data',
    components: {
        CollapseConfirmData
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const after = computed(() => data.value.after);
        const code = ref('A5');
        const sourse = ref([
            { name: '薪資', value: '1' },
            { name: '投資收入', value: '2' },
            { name: '存款', value: '4' },
            { name: '退休金', value: '3' },
            { name: '財產繼承', value: '6' },
            { name: '貸款', value: '7' },
            { name: '保單借款', value: '9' },
            { name: '終止契約(解約)', value: 'B' }
        ]);
        const sourseDisplay = computed(() => {
            const arr = [];

            after.value.singlePremSourceResultData.fundsSourceList.forEach(j => {
                sourse.value.forEach(i => {
                    if (j === i.value) arr.push(i.name);
                });
                if (j === '5') arr.push(after.value.singlePremSourceResultData.fundsMemo);
            });
            return arr.join('、');
        });
        const financialConditionDisplay = computed(() => {
            const { incomeCustA, incomeCustI, chattel, estate, liabilities } = after.value.singlePremSourceResultData;
            const arr = [
                { name: '要保人家庭年收入', amount: incomeCustA, id: 'incomeCustA' },
                { name: '被保險人家庭年收入', amount: incomeCustI, id: 'incomeCustI' },
                { name: '動產(含存款/股票/基金)', amount: chattel, id: 'chattel' },
                { name: '不動產', amount: estate, id: 'estate' },
                { name: '負債', amount: liabilities, id: 'liabilities' }
            ];
            return arr;
        });

        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, data, after, sourseDisplay, financialConditionDisplay, removeService, addComma };
    },
};
</script>
<style lang="scss" scoped>
.dashed {
    @apply pt-1 md:pt-2 pb-1 md:pb-2 first:pt-0 last:pb-0.5;
}
</style>
